import React, { useState, useEffect } from 'react';
import './Page.css';
import { getActiveEvent, getRegistrations } from '../services/api';

const Registrants = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [event, setEvent] = useState(null);
  const [registrations, setRegistrations] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        setError('');
        
        const activeEvent = await getActiveEvent();
        setEvent(activeEvent);
        
        const registrationsData = await getRegistrations(activeEvent.id);
        setRegistrations(registrationsData || []);
      } catch (err) {
        console.error('Error fetching registrations:', err);
        setError('Failed to load registrations. Please try again later.');
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) {
    return (
      <div className="page">
        <h1>Registrants</h1>
        <p>Loading registrations...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="page">
        <h1>Registrants</h1>
        <div className="error-message">{error}</div>
      </div>
    );
  }

  const totalSpots = registrations.reduce((sum, reg) => sum + reg.numberOfPlayers, 0);
  const availableSpots = (event?.maxSpots || 100) - totalSpots;

  return (
    <div className="page">
      <h1>Registrants</h1>
      {event && (
        <div style={{ marginBottom: '2rem', padding: '1rem', backgroundColor: '#f0f0f0', borderRadius: '4px' }}>
          <h2>{event.name}</h2>
          <p><strong>Total Spots:</strong> {event.maxSpots || 100}</p>
          <p><strong>Registered Spots:</strong> {totalSpots}</p>
          <p><strong>Available Spots:</strong> {availableSpots}</p>
        </div>
      )}
      
      {registrations.length === 0 ? (
        <p>No registrations yet.</p>
      ) : (
        <div className="registrations-table">
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ backgroundColor: '#f0f0f0' }}>
                <th style={{ padding: '0.75rem', textAlign: 'left', borderBottom: '2px solid #ddd' }}>Contact Name</th>
                <th style={{ padding: '0.75rem', textAlign: 'left', borderBottom: '2px solid #ddd' }}>Email</th>
                <th style={{ padding: '0.75rem', textAlign: 'left', borderBottom: '2px solid #ddd' }}>Phone</th>
                <th style={{ padding: '0.75rem', textAlign: 'left', borderBottom: '2px solid #ddd' }}>Team Name</th>
                <th style={{ padding: '0.75rem', textAlign: 'left', borderBottom: '2px solid #ddd' }}>Players</th>
                <th style={{ padding: '0.75rem', textAlign: 'left', borderBottom: '2px solid #ddd' }}>Registered Date</th>
              </tr>
            </thead>
            <tbody>
              {registrations.map((reg) => (
                <tr key={reg.id} style={{ borderBottom: '1px solid #ddd' }}>
                  <td style={{ padding: '0.75rem' }}>{reg.contactName}</td>
                  <td style={{ padding: '0.75rem' }}>{reg.email}</td>
                  <td style={{ padding: '0.75rem' }}>{reg.phone || 'N/A'}</td>
                  <td style={{ padding: '0.75rem' }}>{reg.teamName || 'N/A'}</td>
                  <td style={{ padding: '0.75rem' }}>{reg.numberOfPlayers}</td>
                  <td style={{ padding: '0.75rem' }}>
                    {reg.registeredDate 
                      ? new Date(reg.registeredDate).toLocaleDateString()
                      : 'N/A'}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default Registrants;

